export const ADDRESS_PROVIDER = {
  MANUAL: 'MANUAL',
  BROWSER_GPS: 'BROWSER_GPS',
}